import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.to-string';
import _Reflect$construct from '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _classCallCheck from '@babel/runtime-corejs3/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GroupContext } from './group-context.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CheckboxManager = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxManager, _Component);

  var _super = _createSuper(CheckboxManager);

  function CheckboxManager(props) {
    var _this;

    _classCallCheck(this, CheckboxManager);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addToValue", function (val) {
      var onChange = _this.props.onChange;

      if (!_this.state.isControlled) {
        _this.setState(function (prevState) {
          var _context;

          return {
            value: _concatInstanceProperty(_context = prevState.value).call(_context, val)
          };
        });
      } else if (onChange) {
        var _context2;

        onChange(_concatInstanceProperty(_context2 = _this.props.value).call(_context2, val));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeFromValue", function (val) {
      var onChange = _this.props.onChange;

      if (!_this.state.isControlled) {
        _this.setState(function (prevState) {
          var _context3;

          return {
            value: _filterInstanceProperty(_context3 = prevState.value).call(_context3, function (v) {
              return v !== val;
            })
          };
        });
      } else if (onChange) {
        var _context4;

        onChange(_filterInstanceProperty(_context4 = _this.props.value).call(_context4, function (v) {
          return v !== val;
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckboxChange", function (e) {
      if (e.target.checked) {
        _this.addToValue(e.target.value);
      } else {
        _this.removeFromValue(e.target.value);
      }
    });

    _this.state = {
      value: props.defaultValue || []
    };
    return _this;
  }

  _createClass(CheckboxManager, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onChange = this.props.onChange; // call onChange in uncontrolled mode

      if (!this.state.isControlled && onChange && prevState.value !== this.state.value) {
        onChange(this.state.value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state,
          props = this.props,
          handleCheckboxChange = this.handleCheckboxChange;
      var isControlled = state.isControlled;
      var error = props.error,
          theme = props.theme,
          disabled = props.disabled,
          size = props.size;

      var _ref = isControlled ? props : state,
          value = _ref.value;

      return React.createElement(GroupContext.Provider, {
        value: {
          value: value,
          handleCheckboxChange: handleCheckboxChange,
          error: error,
          theme: theme,
          disabled: disabled,
          size: size,
          inGroup: true
        }
      }, props.children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      return {
        isControlled: typeof nextProps.value !== 'undefined'
      };
    }
  }]);

  return CheckboxManager;
}(Component);

_defineProperty(CheckboxManager, "propTypes", {
  onChange: PropTypes.func,
  value: PropTypes.array,
  defaultValue: PropTypes.array,
  error: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark']),
  size: PropTypes.oneOf(['xs', 's', 'm']),
  disabled: PropTypes.bool
});

_defineProperty(CheckboxManager, "onChangeType", 'value');

export { CheckboxManager as default };
